import { apiGet } from 'src/shared/utils/api-request';

export const getUserAccountsAPI = async () => {
  const res = await apiGet('user/accounts');
  return res;
};
